module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loaded),
      expression: "!loaded"
    }]
  }), _vm._v(" "), (_vm.routeName) ? _c('div', [_c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1ghp2d3_oaKg_DvJQxufXlXWvIkKQSJOl/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("CR Risk Layer Map Guide")])]) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('iframe', {
    ref: "mapIframe",
    staticStyle: {
      "width": "100%",
      "border": "none",
      "overflow": "hidden",
      "max-height": "83vh"
    },
    attrs: {
      "id": "iframeMap",
      "src": _vm.iframe.src,
      "frameborder": 0,
      "onload": "javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+\"px\"; o.style.maxHeight=\"83vh\";}(this));",
      "height": _vm.iframe.style.height
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30bdd872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MapNew.vue
// module id = 917
// module chunks = 1